export const settingsNav = (logOut) => [{ label: "Signout", action: logOut }];

export const settingsUser = (active) => (action, changePassword) =>
  [
    { label: `${active ? "Deactivate" : "Reactivate"} User`, action: action },
    { label: `Change Password`, action: changePassword },
  ];
